import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Household Burden Chart
 * Shows household health burden by income decile - current vs SAFECARE
 */
export default function HouseholdBurdenChart({ data }) {
    const chartData = data.map(decile => ({
        decile: decile.label,
        'Current System': decile.current.percent.toFixed(1),
        'SAFECARE': decile.safecare.percent.toFixed(1)
    }));

    return (
        <div className="chart-container">
            <h3>Household Health Burden by Income</h3>
            <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', marginBottom: '1.5rem', fontWeight: 500 }}>
                Health costs as % of income
            </p>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" />
                    <XAxis
                        dataKey="decile"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        angle={-45}
                        textAnchor="end"
                        height={80}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        label={{ value: '% of Income', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.96)',
                            border: '1px solid var(--glass-border)',
                            borderRadius: '12px',
                            color: 'var(--text-primary)',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            fontSize: '13px'
                        }}
                        formatter={(value) => `${value}%`}
                    />
                    <Legend
                        wrapperStyle={{ color: 'var(--text-primary)', fontSize: '12px', fontWeight: 600, paddingTop: '10px' }}
                    />
                    <Bar dataKey="Current System" fill="#ff6b6b" />
                    <Bar dataKey="SAFECARE" fill="#00d4ff" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
